
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referenzen",
      function () {
        return require("private-next-pages/referenzen.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referenzen"])
      });
    }
  